export default {
    props: { departments_projects: Object },
    computed: {
        
    }, 
    methods:{
      
    }

}